import { NextRouter } from 'next/router';
import { useCheckAgeVerification } from '../use-check-age-verification';

type UseRedirectVerifiedCustomerProps = {
  userId: string | undefined;
  dispensaryId: string | undefined;
  router: NextRouter;
  href: string;
};

export function useRedirectVerifiedCustomers({
  userId,
  dispensaryId,
  router,
  href,
}: UseRedirectVerifiedCustomerProps): void {
  const { isAgeVerified, loading } = useCheckAgeVerification({ userId, dispensaryId });

  if (!loading && isAgeVerified) {
    void router.replace(href);
  }
}
